import { formatters } from '../services/api';

const isPaymentSettled = (payment) => {
  const hasPaymentDate = payment?.pagamento && payment.pagamento !== '-';
  const isStatusPaid = (payment?.status || '').toString().toLowerCase() === 'pago';
  return Boolean(hasPaymentDate || isStatusPaid);
};

const getVencimentoValue = (payment) =>
  payment?.vencimento ||
  payment?.vencimentoFormatado ||
  payment?.dataVencimento ||
  null;

const getPaymentIdentity = (payment) =>
  payment?.seq ??
  payment?.idBoleto ??
  payment?.originalData?.idBoleto ??
  payment?.originalData?.SEQ ??
  null;

const parseMesAno = (mesAno) => {
  if (!mesAno || typeof mesAno !== 'string') return null;

  const monthNames = [
    'janeiro', 'fevereiro', 'marco', 'abril', 'maio', 'junho',
    'julho', 'agosto', 'setembro', 'outubro', 'novembro', 'dezembro'
  ];

  const [monthPart, yearPart] = mesAno.split('/');
  const year = Number(yearPart);
  if (!monthPart || !Number.isFinite(year)) return null;

  // Aceita MM/YYYY
  const numericMonth = Number(monthPart);
  if (Number.isFinite(numericMonth) && numericMonth >= 1 && numericMonth <= 12) {
    return new Date(year, numericMonth - 1, 1);
  }

  const normalized = monthPart
    .trim()
    .toLowerCase()
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '');
  const monthIndex = monthNames.indexOf(normalized);
  if (monthIndex < 0) return null;

  return new Date(year, monthIndex, 1);
};

export const getPaymentDueDate = (payment) => {
  const raw = getVencimentoValue(payment);
  const fromVencimento = formatters.parseLocalDate(raw);
  if (fromVencimento && !Number.isNaN(fromVencimento.getTime())) {
    fromVencimento.setHours(0, 0, 0, 0);
    return fromVencimento;
  }

  const fromMesAno = parseMesAno(payment?.mesAno);
  if (fromMesAno && !Number.isNaN(fromMesAno.getTime())) {
    fromMesAno.setHours(0, 0, 0, 0);
    return fromMesAno;
  }

  return null;
};

/**
 * Retorna a cobrança em aberto mais antiga com vencimento anterior à clicada.
 * Se a clicada já for a mais antiga em aberto, retorna null.
 */
export const findOldestPreviousOpenCharge = (clickedPayment, allPayments = []) => {
  if (!clickedPayment || !Array.isArray(allPayments) || allPayments.length === 0) {
    return null;
  }

  const clickedDue = getPaymentDueDate(clickedPayment);
  if (!clickedDue) return null;

  const clickedId = getPaymentIdentity(clickedPayment);

  const previousOpen = allPayments.filter((payment) => {
    if (!payment || isPaymentSettled(payment)) return false;

    const identity = getPaymentIdentity(payment);
    if (clickedId != null && identity != null && String(clickedId) === String(identity)) {
      return false;
    }

    const due = getPaymentDueDate(payment);
    if (!due) return false;

    return due.getTime() < clickedDue.getTime();
  });

  if (previousOpen.length === 0) return null;

  return previousOpen.reduce((oldest, current) => {
    const oldestDue = getPaymentDueDate(oldest);
    const currentDue = getPaymentDueDate(current);
    if (!oldestDue) return current;
    if (!currentDue) return oldest;
    return currentDue.getTime() < oldestDue.getTime() ? current : oldest;
  });
};
